module.exports = __webpack_public_path__ + "static/img/0774.1c23d83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0774.jpg
// module id = 112
// module chunks = 0